import { z } from "zod";

export const triggerCustomEventPropertiesFilterGetSchema = z.object({
  filter_key: z.literal("custom_event_properties_filter"),
  additional_filter_data: z.strictObject({}),
  allowed_for_predictions: z.literal(false),
  allowed_for_territories: z.literal(false),
  varies_by_app_group: z.literal(true),
  only_for_workflow_step: z.literal(false),
  comparison_key: z.enum(["1", "2", "3", "4", "5", "6", "10", "11", "12", "15", "16", "17"]),
  display_name: z.string(),
  value: z.union([
    z.boolean(),
    z.number(),
    z.string(),
    z.null(),
    z.object({
      value: z.union([z.boolean(), z.number(), z.string(), z.null()]),
      personalization_type: z.string(),
    }),
  ]),
});

export const triggerNestedObjectFilterGetSchema = z.object({
  filter_key: z.literal("nested_object_filter"),
  additional_filter_data: z.strictObject({}),
  allowed_for_predictions: z.literal(false),
  allowed_for_territories: z.literal(false),
  comparison_key: z.string().regex(/^\d+-\d+$/), // Matches "1-1", "2-3", etc.
  display_name: z.literal("Nested Property"),
  only_for_workflow_step: z.literal(false),
  value: z.object({
    // null: 69 (1.18%)
    nested_property_name: z.string().nullable(),
    nested_property_value: z.union([z.boolean(), z.number(), z.string(), z.array(z.string())]),
  }),
  varies_by_app_group: z.literal(false),
});

export const triggerOrFilterGetSchema = z.object({
  filter_key: z.literal("or_behavior_condition_filter"),
  additional_filter_data: z.strictObject({}),
  allowed_for_predictions: z.literal(false),
  allowed_for_territories: z.literal(false),
  varies_by_app_group: z.literal(false),
  only_for_workflow_step: z.literal(false),
  comparison_key: z.literal("1"),
  display_name: z.literal(""),
  filters: z.array(
    z.discriminatedUnion("filter_key", [
      triggerCustomEventPropertiesFilterGetSchema,
      triggerNestedObjectFilterGetSchema,
    ])
  ),
  value: z.null(),
});

export const triggerFiltersGetSchema = z.array(
  z.discriminatedUnion("filter_key", [
    triggerCustomEventPropertiesFilterGetSchema,
    triggerNestedObjectFilterGetSchema,
    triggerOrFilterGetSchema,
  ])
);
